module.exports = __webpack_public_path__ + "static/media/truck1.42111392.jpg";